import _classCallCheck from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import ReactDOM from 'react-dom';
import { CustomElementIs } from './CustomElement';
import '@vaadin/vaadin-grid/all-imports';
export var Grid = /*#__PURE__*/function (_CustomElementIs) {
  _inherits(Grid, _CustomElementIs);

  function Grid() {
    var _this;

    _classCallCheck(this, Grid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Grid).call(this));

    _this.propertyBlacklist.push('rowDetailsRenderer');

    return _this;
  }

  _createClass(Grid, [{
    key: "_configRef",
    value: function _configRef(grid) {
      var _this2 = this;

      if (this.props.rowDetailsRenderer) {
        grid.rowDetailsRenderer = grid.rowDetailsRenderer || function (root, grid, model) {
          ReactDOM.render(_this2.props.rowDetailsRenderer(model), root);
        };
      }
    }
  }]);

  return Grid;
}(CustomElementIs('vaadin-grid'));
export var GridColumn = /*#__PURE__*/function (_CustomElementIs2) {
  _inherits(GridColumn, _CustomElementIs2);

  function GridColumn() {
    var _this3;

    _classCallCheck(this, GridColumn);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(GridColumn).call(this));

    _this3.propertyBlacklist.push('renderer');

    return _this3;
  }

  _createClass(GridColumn, [{
    key: "_configRef",
    value: function _configRef(column) {
      var _this4 = this;

      if (this.props.renderer) {
        column.renderer = column.renderer || function (root, grid, model) {
          ReactDOM.render(_this4.props.renderer(model), root);
        };
      }

      if (this.props.headerComponent) {
        column.headerRenderer = column.headerRenderer || function (root) {
          ReactDOM.render(_this4.props.headerComponent, root);
        };
      }
    }
  }]);

  return GridColumn;
}(CustomElementIs('vaadin-grid-column'));
export var GridColumnGroup = /*#__PURE__*/function (_CustomElementIs3) {
  _inherits(GridColumnGroup, _CustomElementIs3);

  function GridColumnGroup() {
    _classCallCheck(this, GridColumnGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(GridColumnGroup).apply(this, arguments));
  }

  return GridColumnGroup;
}(CustomElementIs('vaadin-grid-column-group'));
export var GridSelectionColumn = /*#__PURE__*/function (_GridColumn) {
  _inherits(GridSelectionColumn, _GridColumn);

  function GridSelectionColumn() {
    var _this5;

    _classCallCheck(this, GridSelectionColumn);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(GridSelectionColumn).call(this));
    _this5.tagName = 'vaadin-grid-selection-column';
    return _this5;
  }

  return GridSelectionColumn;
}(GridColumn);
export var GridSortColumn = /*#__PURE__*/function (_GridColumn2) {
  _inherits(GridSortColumn, _GridColumn2);

  function GridSortColumn() {
    var _this6;

    _classCallCheck(this, GridSortColumn);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(GridSortColumn).call(this));
    _this6.tagName = 'vaadin-grid-sort-column';
    return _this6;
  }

  return GridSortColumn;
}(GridColumn);
export var GridFilterColumn = /*#__PURE__*/function (_GridColumn3) {
  _inherits(GridFilterColumn, _GridColumn3);

  function GridFilterColumn() {
    var _this7;

    _classCallCheck(this, GridFilterColumn);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(GridFilterColumn).call(this));
    _this7.tagName = 'vaadin-grid-filter-column';
    return _this7;
  }

  return GridFilterColumn;
}(GridColumn);
export var GridTreeColumn = /*#__PURE__*/function (_GridColumn4) {
  _inherits(GridTreeColumn, _GridColumn4);

  function GridTreeColumn() {
    var _this8;

    _classCallCheck(this, GridTreeColumn);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(GridTreeColumn).call(this));
    _this8.tagName = 'vaadin-grid-tree-column';
    return _this8;
  }

  return GridTreeColumn;
}(GridColumn);